import React, { useState, useEffect } from 'react'
import './ActiveProducts.css'

import TeamHeader from '../TeamHeader/TeamHeader';
import { Link } from 'react-router-dom';

// Icons
import { IoIosLock } from "react-icons/io";

// Assets
import foreFlightImg from '../../client-dashboard/client-dashboard-assets/product-suit-assets/fore-flight.png'
import foreFlightLogo from '../../client-dashboard/client-dashboard-assets/product-suit-assets/fore-flight-logo.png'

import fiResponseImg from '../../client-dashboard/client-dashboard-assets/product-suit-assets/firesponse-img.jpg'
import fiResponseLogo from '../../client-dashboard/client-dashboard-assets/product-suit-assets/firesponse-logo.png'

import intterraImg from '../../client-dashboard/client-dashboard-assets/product-suit-assets/intterra-img.png'
import intterraLogo from '../../client-dashboard/client-dashboard-assets/product-suit-assets/intterra-logo.png'

import alertwestImg from '../../client-dashboard/client-dashboard-assets/product-suit-assets/alertwest-img.jpg'
import alertwestLogo from '../../client-dashboard/client-dashboard-assets/product-suit-assets/alertwest-logo.png'

import gridosImg from '../../client-dashboard/client-dashboard-assets/product-suit-assets/gridos-img.jpg'
import gridosLogo from '../../client-dashboard/client-dashboard-assets/product-suit-assets/gridos-logo.png'

import apiendpointImg from '../../client-dashboard/client-dashboard-assets/product-suit-assets/apiendpoint-img.jpg'
import apiendpointLogo from '../../pages/HeaderFolder/img/FNNLogoWithBlackFont-06.png'

import emaildispatchImg from '../../client-dashboard/client-dashboard-assets/product-suit-assets/emaildispatch-img.png'
import hrlforecastImg from '../../client-dashboard/client-dashboard-assets/product-suit-assets/hrlforecast-img.jpg'
import firespreadImg from '../../client-dashboard/client-dashboard-assets/product-suit-assets/firespread-img.jpg'
import rawDataImg from '../../client-dashboard/client-dashboard-assets/product-suit-assets/rawdata-img.jpg'


const ActiveProducts = () => {

    useEffect(() => {
        window.scrollTo(0, 0); // Scroll to the top when the component mounts
    }, []);

    const products = [
        { title: 'ForeFlight', image: foreFlightImg, logo: foreFlightLogo, linkTo: '/marketing/products/foreflight', isLocked: false },
        { title: 'API Endpoint', image: apiendpointImg, logo: apiendpointLogo, linkTo: '/marketing/products/api_endpoint', isLocked: false },
        { title: 'Email Dispatch', image: emaildispatchImg, logo: apiendpointLogo, linkTo: '/marketing/products/email_dispatch', isLocked: false },
        { title: 'HRL Detector Data', image: rawDataImg, logo: apiendpointLogo, linkTo: '/marketing/products/hrl_detector_data', isLocked: false },
        { title: 'fiResponse', image: fiResponseImg, logo: fiResponseLogo, linkTo: '/marketing/products/firesponse', isLocked: true },
        { title: 'Intterra', image: intterraImg, logo: intterraLogo, linkTo: '/marketing/products/intterra', isLocked: true },
        { title: 'AlertWest', image: alertwestImg, logo: alertwestLogo, linkTo: '/marketing/products/alertwest', isLocked: true },
        { title: 'GridOS ADMS', image: gridosImg, logo: gridosLogo, linkTo: '/marketing/products/gridos_adms', isLocked: true },
        { title: 'HRL Forecast', image: hrlforecastImg, logo: apiendpointLogo, linkTo: '/marketing/products/hrl_forecast', isLocked: true },
        { title: 'FireSpread Model', image: firespreadImg, logo: apiendpointLogo, linkTo: '/marketing/products/firespread_model', isLocked: true },
    ];

    const [showPopup, setShowPopup] = useState(false);


    return (
        <div className='customer-directory-body'>
            <TeamHeader title="Marketing" />

            <h1 className='cutomer-title'>Active Products</h1>

            <div className='product-suite-card-stack product-extension'>
                {products.map((product, index) => {

                    const handleClick = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
                        if (product.isLocked) {
                            e.preventDefault();
                            setShowPopup(true);
                        }
                    };

                    return (
                        <Link
                            to={product.linkTo}
                            onClick={handleClick}
                            key={index}
                            className='product-suite-card-link'
                            style={{ textDecoration: 'none' }}
                        >
                            <div className='product-suite-card'>
                                <div className='product-suite-card-img-wrapper'>
                                    <img src={product.image} alt={`${product.title} screenshot`} />
                                </div>

                                <div className='product-suite-card-inner marketing-suite'>
                                    <img
                                        src={product.logo}
                                        alt={`${product.title} logo`}
                                        style={{
                                            maxWidth: product.title === 'ForeFlight' ? '12rem' : undefined,
                                        }}
                                    />
                                    <h2>{product.title}</h2>
                                </div>

                                {/* If locked, show overlay and lock */}
                                {product.isLocked && (
                                    <>
                                        <div className="product-suite-card-overlay" />
                                        <IoIosLock className="product-suite-card-lock-icon" />
                                    </>
                                )}

                            </div>
                        </Link>

                    );
                })}
            </div>

            {showPopup && (
                <div className="suite-popup-overlay">
                    <div className="suite-popup-content">
                        <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-end' }} className='faq-adjust-buttons suite-extension'>
                            <button
                                style={{ paddingLeft: '1rem', paddingRight: '1rem' }}
                                onClick={() => setShowPopup(false)}
                            >
                                <strong>Back</strong>
                            </button>
                        </div>

                        <h1>This Product is Unavailable</h1>
                        <IoIosLock className='lock-icon-popup' />
                        <p>The API for this feature is still under construction.</p>
                        <p>If you have questions regarding the release of this product please reach out to the Website Team.</p>
                    </div>
                </div>
            )}

        </div>
    )
}

export default ActiveProducts